import { ReactElement } from 'react'
import Layout from '../../components/layout'
import ShopSalesManList from '../../components/Shops/SalesMan'

const ShopOrderPage = (): ReactElement => {
  return (
    <Layout >
      <ShopSalesManList />
    </Layout>
  )
}

export default ShopOrderPage
